import { CustomIcon } from './_props'
import { ReactComponent as LogoPrimarySvg } from './logos/ttd-logo-primary.svg'
import { ReactComponent as LogoGreenSvg } from './logos/ttd-logo-green.svg'
import { ReactComponent as LogoWhiteSvg } from './logos/ttd-logo-white.svg'
import { ReactComponent as LogotypeSvg } from './logos/ttd-logotype.svg'
import { ReactComponent as CloseRoundedSvg } from './close-rounded-icon.svg'
import { ReactComponent as AttachementFilledSvg } from './attachement-filled-icon.svg'
import { ReactComponent as EditWhiteSvg } from './edit-white-icon.svg'
import { ReactComponent as ConsultationSvg } from './consultation-icon.svg'
import { ReactComponent as SuccessCheckSvg } from './success-check-icon.svg'
import { ReactComponent as ErrorCheckSvg } from './error-check-icon.svg'
import { ReactComponent as RightPointingArrowSvg } from './right-pointing-arrow-icon.svg'
import { ReactComponent as DownPointingArrowSvg } from './down-pointing-arrow-icon.svg'
import { ReactComponent as WarningSvg } from './warning-icon.svg'
import { ReactComponent as AnnouncementSvg } from './announcement-icon.svg'
import { ReactComponent as ArrowOutwardSvg } from './arrow-outward-icon.svg'
import { ReactComponent as HelpFilledSvg } from './help-filled-icon.svg'
import { ReactComponent as HelpOutlinedSvg } from './help-outlined-icon.svg'
import { ReactComponent as BuildSvg } from './build-icon.svg'
import { ReactComponent as NewsIconSvg } from './news-icon.svg'
import { ReactComponent as SupportAgentSvg } from './support-agent-icon.svg'
import { ReactComponent as PhoneSvg } from './phone-icon.svg'
import { ReactComponent as SuperuserSvg } from './superuser-icon.svg'
import { ReactComponent as ShiftSvg } from './shift-icon.svg'
import { ReactComponent as PersonRoundedSvg } from './person-rounded.svg'
import { ReactComponent as ArrowForwardSvg } from './arrow-forward-icon.svg'
import { ReactComponent as HistorySvg } from './history-rounded.svg'
import { ReactComponent as HistoryOverdueSvg } from './history-overdue.svg'
import { ReactComponent as DeleteRoundedSvg } from './delete-rounded.svg'
import { ReactComponent as EmptySearchPatientSvg } from './EmptyState-Search-Requerant.svg'
import { ReactComponent as DeleteBackgroundSvg } from './delete-state.svg'
import { ReactComponent as ArrowBackwardSvg } from './arrow_back_icon.svg'
import { ReactComponent as ArrowBackwardDisableSvg } from './arrow-back-disable-icon.svg'
import { ReactComponent as ErrorRoundedSvg } from './error-rounded.svg'
import { ReactComponent as HelpExpertiseSvg } from './help-expertise-icon.svg'
import { ReactComponent as EmptyNoLoopExpertiseSvg } from './empty-noloop-expertise.svg'
import { ReactComponent as EmptySearchRequisSvg } from './no-requis-icon.svg'
import { ReactComponent as RequesterHelpSvg } from './requerant-help-icon.svg'
import { ReactComponent as RequesterAddSvg } from './requerant-add-icon.svg'
import { ReactComponent as NoRequesterSvg } from './no-requerant.svg'
import { ReactComponent as FillAddressSvg } from './fill-address-icon.svg'
import { ReactComponent as EmptyWorkflowSvg } from './empty-workflow-icon.svg'
import { ReactComponent as EditBlackSvg } from './edit-black-icon.svg'
import { ReactComponent as EmptySearchRequesterSvg } from './empty-search-requerant.svg'
import { ReactComponent as LogoutRoundedSvg } from './logout-rounded-icon.svg'
import { ReactComponent as ArrowForwardIosSvg } from './arrow_forward_ios.svg'
import { ReactComponent as AttachFileSvg } from './attach-file-icon.svg'
import { ReactComponent as UploadFileSvg } from './upload-file.svg'
import { ReactComponent as VisibilityEyeSvg } from './visibility-eye.svg'
import { ReactComponent as UnderlineSvg } from './Underline.svg'
import { ReactComponent as CrossPurpleSvg } from './cross-purple.svg'
import { ReactComponent as RefreshRoundedSvg } from './refresh-rounded.svg'
import { ReactComponent as ExpiredSvg } from './expired-icon.svg'
import { ReactComponent as SupportHelpSvg } from './support-help-icon.svg'

export const LogoPrimaryIcon: CustomIcon = (props) => <LogoPrimarySvg {...props} />
export const LogoGreenIcon: CustomIcon = (props) => <LogoGreenSvg {...props} />
export const LogoWhiteIcon: CustomIcon = (props) => <LogoWhiteSvg {...props} />
export const LogotypeIcon: CustomIcon = (props) => <LogotypeSvg {...props} />
export const CloseRoundedIcon: CustomIcon = (props) => <CloseRoundedSvg {...props} />
export const AttachementFilledIcon: CustomIcon = (props) => <AttachementFilledSvg {...props} />
export const EditWhiteIcon: CustomIcon = (props) => <EditWhiteSvg {...props} />
export const ConsultationIcon: CustomIcon = (props) => <ConsultationSvg {...props} />
export const SuccessCheckIcon: CustomIcon = (props) => <SuccessCheckSvg {...props} />
export const ErrorCheckIcon: CustomIcon = (props) => <ErrorCheckSvg {...props} />
export const RightPointingArrowIcon: CustomIcon = (props) => <RightPointingArrowSvg {...props} />
export const DownPointingArrowIcon: CustomIcon = (props) => <DownPointingArrowSvg {...props} />
export const ArrowForwardIcon: CustomIcon = (props) => <ArrowForwardSvg {...props} />
export const HistoryRoundedSvg: CustomIcon = (props) => <HistorySvg {...props} />
export const HistoryOverdueIcon: CustomIcon = (props) => <HistoryOverdueSvg {...props} />
export const WarningIcon: CustomIcon = (props) => <WarningSvg {...props} />
export const AnnouncementIcon: CustomIcon = (props) => <AnnouncementSvg {...props} />
export const ArrowOutwardIcon: CustomIcon = (props) => <ArrowOutwardSvg {...props} />
export const HelpFilledIcon: CustomIcon = (props) => <HelpFilledSvg {...props} />
export const HelpOutlinedIcon: CustomIcon = (props) => <HelpOutlinedSvg {...props} />
export const BuildIcon: CustomIcon = (props) => <BuildSvg {...props} />
export const NewsIcon: CustomIcon = (props) => <NewsIconSvg {...props} />
export const SupportAgentIcon: CustomIcon = (props) => <SupportAgentSvg {...props} />
export const PhoneIcon: CustomIcon = (props) => <PhoneSvg {...props} />
export const SuperuserIcon: CustomIcon = (props) => <SuperuserSvg {...props} />
export const ShiftIcon: CustomIcon = (props) => <ShiftSvg {...props} />
export const PersonRoundedIcon: CustomIcon = (props) => <PersonRoundedSvg {...props} />
export const DeleteRoundedIcon: CustomIcon = (props) => <DeleteRoundedSvg {...props} />
export const EmptySearchRequisIcon: CustomIcon = (props) => <EmptySearchRequisSvg {...props} />
export const EmptySearchPatientIcon: CustomIcon = (props) => <EmptySearchPatientSvg {...props} />
export const DeleteBackgroundIcon: CustomIcon = (props) => <DeleteBackgroundSvg {...props} />
export const ArrowBackwardIcon: CustomIcon = (props) => <ArrowBackwardSvg {...props} />
export const ArrowBackwardDisabledIcon: CustomIcon = (props) => <ArrowBackwardDisableSvg {...props} />
export const ErrorRoundedIcon: CustomIcon = (props) => <ErrorRoundedSvg {...props} />
export const HelpExpertiseIcon: CustomIcon = (props) => <HelpExpertiseSvg {...props} />
export const EmptyNoLoopExpertiseIcon: CustomIcon = (props) => <EmptyNoLoopExpertiseSvg {...props} />
export const RequesterHelpIcon: CustomIcon = (props) => <RequesterHelpSvg {...props} />
export const RequesterAddIcon: CustomIcon = (props) => <RequesterAddSvg {...props} />
export const NoRequesterIcon: CustomIcon = (props) => <NoRequesterSvg {...props} />
export const FillAddressIcon: CustomIcon = (props) => <FillAddressSvg {...props} />
export const EmptyWorkflowIcon: CustomIcon = (props) => <EmptyWorkflowSvg {...props} />
export const EditBlackIcon: CustomIcon = (props) => <EditBlackSvg {...props} />
export const EmptySearchRequesterIcon: CustomIcon = (props) => <EmptySearchRequesterSvg {...props} />
export const LogoutRoundedIcon: CustomIcon = (props) => <LogoutRoundedSvg {...props} />
export const ArrowForwardIosIcon: CustomIcon = (props) => <ArrowForwardIosSvg {...props} />
export const AttachFileIcon: CustomIcon = (props) => <AttachFileSvg {...props} />
export const UploadFileIcon: CustomIcon = (props) => <UploadFileSvg {...props} />
export const VisibilityEyeIcon: CustomIcon = (props) => <VisibilityEyeSvg {...props} />
export const UnderlineIcon: CustomIcon = (props) => <UnderlineSvg {...props} />
export const CrossPurpleIcon: CustomIcon = (props) => <CrossPurpleSvg {...props} />
export const RefreshRoundedIcon: CustomIcon = (props) => <RefreshRoundedSvg {...props} />
export const ExpiredIcon: CustomIcon = (props) => <ExpiredSvg {...props} />
export const SupportHelpIcon: CustomIcon = (props) => <SupportHelpSvg {...props} />
